module.exports = __webpack_public_path__ + "img/Feature.299ccc68.png";